export const MAX_COMPANY_NAME_LENGTH = 80;
export const MAX_REGISTRATION_NUMBER_LENGTH = 15;
export const MAX_TAX_ID_LENGTH = 20;
export const MAX_LICENSE_NUMBER_LENGTH = 20;
export const MAX_YEARS_IN_BUSINESS_LENGTH = 3;
export const MAX_INDUSTRIES_LENGTH = 12;
export const MAX_ADDRESS_FIELD_LENGTH = 50;
export const MAX_PO_BOX_LENGTH = 10;
export const MAX_GLOBAL_INTERMEDIARY_ID_LENGTH = 50;
export const Max_MAKANI_NUMBER_LENGTH = 20;

export const WAGE_PROTECTION_OPTIONS = [
  {
    key: "bankName",
    code: "bankName",
    displayText: "Bank",
    value: "Bank",
    subGroup: null
  },
  {
    key: "exchangeHouse",
    code: "exchangeHouse",
    displayText: "Exchange house",
    value: "Exchange House",
    subGroup: null
  },
  {
    key: "other",
    code: "other",
    displayText: "Other",
    value: "Other",
    subGroup: null
  }
];

export const PERCENTAGE_ANNUAL_INTERVALS = [
  { code: "0", key: "0", value: "0", displayText: "0" },
  { code: "1", key: "1", value: "1", displayText: "1" },
  { code: "10", key: "10", value: "10", displayText: "10" },
  { code: "20", key: "20", value: "20", displayText: "20" },
  { code: "30", key: "30", value: "30", displayText: "30" },
  { code: "40", key: "40", value: "40", displayText: "40" },
  { code: "50", key: "50", value: "50", displayText: "50" },
  { code: "60", key: "60", value: "60", displayText: "60" },
  { code: "70", key: "70", value: "70", displayText: "70" },
  { code: "80", key: "80", value: "80", displayText: "80" },
  { code: "90", key: "90", value: "90", displayText: "90" },
  { code: "100", key: "100", value: "100", displayText: "100 %" }
];
export const SPLIT_OPTIONS = [{ value: -50, label: "50 %" }, { value: 50, label: "50 %" }];

export const PERCENTAGE_ANNUAL_SALES = "What is % of annual sales within this industry?";
export const SPLIT_BTW_INTERNATIONAL_LOCAL_SALES =
  "What is the split between the company's international and local sales?";
export const SPLIT_BTW_WHOLESALE_RETAIL_TRADE =
  "What is company split between wholesale and retail trade";

export const PRE_ELIGIBILITY_COMPANY_INFO_PAGE_ID = "pre-eligibility-companyInfo";
export const IS_VAT_EXEMPT = "Is your company VAT Exempt?";
export const DOES_OUTSOURCE = "Does the company outsource staff?";
export const WAGE_PROTECTION_SYSTEM_ROUTE = "Where is the staff salary (WPS) being routed from?";

export const SHOW_GOOGLE_ADDRESS = "Show address on google maps";
export const YES_NO_OPTIONS = [
  {
    key: "yes",
    code: "yes",
    label: "Yes",
    displayText: "Yes",
    value: "yes",
    subGroup: null
  },
  {
    key: "no",
    code: "no",
    label: "No",
    displayText: "No",
    value: "no",
    subGroup: null
  }
];

export const ACTIVE_PASSIVE_OPTIONS = [
  {
    key: "active",
    code: "active",
    displayText: "Active",
    value: "active",
    subGroup: null
  },
  {
    key: "passive",
    code: "passive",
    displayText: "Passive",
    value: "passive",
    subGroup: null
  }
];
const Manufacturing = "MFG";
const Service = "SER";
const Transport = "TSC";
const GENERAL_TRADING = "GT";
const RETAIL_TRADING = "RT";
const WHOLESALE_TRADING = "WST";

export const INDUSTRY_OPTIONS = [Manufacturing, Service, Transport];
export const TRADING_TYPES = [GENERAL_TRADING, RETAIL_TRADING, WHOLESALE_TRADING];

export const internationalType = true;

export const PREMISES_TYPE_OTHER_OPTION_CODE = "6";
